import {NgModule} from "@angular/core";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {FraisPrestationsComponent} from "./frais-prestations.component";
import {PrestationsListeComponent} from "@components/admin/frais/prestations/prestations-liste/prestations-liste.component";
import {DroitAdmin} from "@core/security/droit-admin";
import {PrestationAdminListItemComponent} from "@components/admin/frais/prestations/prestations-liste/prestation-list-item/prestation-admin-list-item.component";
import {MontantPipe} from "@share/pipe/montant";
import {PrestationDetailComponent} from "@components/admin/frais/prestations/prestation-detail/prestation-detail.component";
import {PrestationGeneralitesComponent} from "@components/admin/frais/prestations/prestation-detail/generalites/prestation-generalites.component";
import {PrestationReglesGestionComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/prestation-regles-gestion.component";
import {PrestationZuComponent} from "@components/admin/frais/prestations/prestation-detail/zu/prestation-zu.component";
import {PrestationFiltresComponent} from "@components/admin/frais/prestations/prestation-detail/filtres/prestation-filtres.component";
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";
import {ProprietaireModule} from "@share/component/proprietaire/proprietaire.module";
import {ZoneUtilisateurModule} from "@components/zone-utilisateur/zone-utilisateur.module";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {AddCompteChargeComponent} from "@components/admin/frais/prestations/prestation-detail/generalites/add-compte-charge.component";
import {ZonePredefinieModule} from "@components/zone-predefinie/zone-predefinie.module";
import {AddCumulComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/add-cumul.component";
import {AddCompteExterneComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/add-compte-externe.component";
import {ZuListItemComponent} from "@components/admin/frais/prestations/prestation-detail/zu/zu-list-item.component";
import {AddZuComponent} from "@components/admin/frais/prestations/prestation-detail/zu/add-zu.component";
import {BaremePopinComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-popin.component";
import {BaremeListItemComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-list-item.component";
import {BaremeDetailPopinComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/bareme-detail-popin.component";
import {FiltreListItemComponent} from "@components/admin/frais/prestations/prestation-detail/filtres/filtre-list-item.component";
import {PopinAjoutFiltresComponent} from "@components/admin/frais/prestations/prestation-detail/filtres/popin-ajout-filtres/popin-ajout-filtres.component";
import {AjoutFiltreItemComponent} from "@components/admin/frais/prestations/prestation-detail/filtres/popin-ajout-filtres/ajout-filtre-item/ajout-filtre-item.component";
import {MontantDetailComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/montant-popin/montant-detail.component";
import {MontantListItemComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/montant-popin/montant-list-item.component";
import {MontantPopinComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/montant-popin/montant-popin.component";

export const fraisPrestationsRoutes : Routes = [
    {
        path: 'Liste',
        component: PrestationsListeComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_PRESTATION_NDF] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Liste'
    }, {
        path: '**',
        redirectTo: 'Liste'
    }
];

export const prestationOngletRoutes : Routes = [
    {
        path: 'Generalites',
        component: PrestationGeneralitesComponent,
        data: {sousAdminCredentials: [DroitAdmin.DROIT_PRESTATION_NDF]}
    }, {
        path: 'Regles',
        component: PrestationReglesGestionComponent,
        data: {sousAdminCredentials: [DroitAdmin.DROIT_PRESTATION_NDF]}
    }, {
        path: 'Zu',
        component: PrestationZuComponent,
        data: {sousAdminCredentials: [DroitAdmin.DROIT_PRESTATION_NDF]}
    }, {
        path: 'Filtres',
        component: PrestationFiltresComponent,
        data: {sousAdminCredentials: [DroitAdmin.DROIT_PRESTATION_NDF]}
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Generalites'
    }, {
        path: '**',
        redirectTo: 'Generalites'
    }
];

@NgModule({
    imports: [
        ShareModule,
        PreviewAlerteModule,
        ProprietaireModule,
        ZoneUtilisateurModule,
        ZonePredefinieModule
    ],
    declarations: [
        FraisPrestationsComponent,
        PrestationsListeComponent,
        PrestationAdminListItemComponent,
        PrestationDetailComponent,
        PrestationGeneralitesComponent,
        PrestationReglesGestionComponent,
        PrestationZuComponent,
        PrestationFiltresComponent,
        AddCompteChargeComponent,
        AddCumulComponent,
        AddCompteExterneComponent,
        ZuListItemComponent,
        AddZuComponent,
        BaremePopinComponent,
        BaremeListItemComponent,
        BaremeDetailPopinComponent,
        FiltreListItemComponent,
        PopinAjoutFiltresComponent,
        AjoutFiltreItemComponent,
        MontantListItemComponent,
        MontantDetailComponent,
        MontantPopinComponent
    ],
    exports: [
        PrestationsListeComponent,
        PrestationAdminListItemComponent,
        PrestationGeneralitesComponent,
        PrestationReglesGestionComponent,
        PrestationZuComponent,
        PrestationFiltresComponent,
        AddCompteChargeComponent,
        AddCumulComponent,
        AddCompteExterneComponent,
        ZuListItemComponent,
        AddZuComponent,
        BaremePopinComponent,
        BaremeListItemComponent,
        BaremeDetailPopinComponent,
        FiltreListItemComponent,
        PopinAjoutFiltresComponent,
        AjoutFiltreItemComponent
    ],
    providers: [
        MontantPipe,
        PrestationService
    ]
})
export class FraisPrestationsModule {}
